import * as THREE from 'three'
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js'

/**
 * PMREM 烘焙时的 Gaussian σ（弧度）。
 *
 * 与 `three.js-187/examples/test2.html` 的 `pmremGenerator.fromScene(new RoomEnvironment(), 0.04).texture`
 * 保持完全一致：在 RoomEnvironment 上多做一次轻度模糊，避免 `roughness = 0` 的金属/玻璃材质
 * 把房间几何「锐利地」映在机身表面，呈现产品摄影更常见的柔和反射。
 *
 * 不要随意调大，过大会让中等粗糙度（≈0.3–0.6）的金属看起来像绒面，与作者贴图相冲。
 */
export const CLASSIC_ROOM_ENVIRONMENT_PMREM_SIGMA = 0.04

/**
 * 烘焙 Three.js 编辑器同款 {@link RoomEnvironment} 为 PMREM，供 `scene.environment` 使用（非 HDR 文件）。
 *
 * @param pmremGenerator - 与主渲染器绑定的 PMREM 实例
 * @returns 调用方在切换环境时须 `dispose` 的 RenderTarget
 */
export function bakeClassicRoomEnvironmentPmrem(
  pmremGenerator: THREE.PMREMGenerator,
): THREE.WebGLRenderTarget {
  const room = new RoomEnvironment()
  const target = pmremGenerator.fromScene(room, CLASSIC_ROOM_ENVIRONMENT_PMREM_SIGMA)
  room.traverse((obj) => {
    if (!(obj instanceof THREE.Mesh)) return
    obj.geometry.dispose()
    const m = obj.material
    if (Array.isArray(m)) m.forEach((x) => x.dispose())
    else m.dispose()
  })
  return target
}
